import request from "../utils/request";
const diagnosisApi = {
    diagList: '/diag/diagnosis',
    diagSort: '/diag/diagnosis/sort',
}
export function getDiagSortApi(params) {
    return request({
        url: diagnosisApi.diagList,
        method: 'get',
        params
    })
}


export function updateDiagSortApi(parameter) {
    return request({
        url: diagnosisApi.diagSort,
        method: 'post',
        data: parameter,
    });
}